import { render, staticRenderFns } from "./TriageAnswer.vue?vue&type=template&id=e743b480&scoped=true&"
import script from "./TriageAnswer.vue?vue&type=script&lang=js&"
export * from "./TriageAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TriageAnswer.vue?vue&type=style&index=0&id=e743b480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e743b480",
  null
  
)

export default component.exports